import { getMediaTagsByType, IMediaModel } from "@nf/common";
import { RouteHelper } from "helpers/routeHelper";
import { useMemo } from "react";

import Button from "components/Button";

import styles from "./MediaCategories.module.scss";

interface MediaCategoriesProps {
  media: IMediaModel;
}

const MediaCategories = ({ media }: MediaCategoriesProps) => {
  const categories = useMemo(
    () => getMediaTagsByType(media?.Categories),
    [media?.Categories]
  );

  if (!categories.length) {
    return null;
  }

  return (
    <div className={styles.categories}>
      {categories?.map((category) => (
        <Button
          key={category.CategoryId}
          href={RouteHelper.goToGenre(category.CategoryId)}
          variant="chip"
        >
          {category.CategoryName}
        </Button>
      ))}
    </div>
  );
};

export default MediaCategories;
